import {
  Avatar,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import React, { Suspense, lazy } from "react";
import TopViewNav from "../../CommonComponents/TopViewNav";
import { useState } from "react";
import { Box } from "@mui/system";
import { useNavigate } from "react-router";
import { useLocalStorage } from "../../../Hooks/Index";
import { VehicleActions } from "../../../actions/VehicleActions";
import { useEffect } from "react";

const VehicleType = () => {
  const navigate = useNavigate();

  const [selectedSite] = useLocalStorage("selectedSite", null);

  const [vehicleTypeList, setVehicleTypeList] = useState([]);

  // ---- Dialog state ----
  const [openDialog, setOpenDialog] = useState(false);
  const [vehicleTypeInput, setVehicleTypeInput] = useState("");
  const [vehicleTypeError, setVehicleTypeError] = useState("");
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null); // null = add mode, otherwise = edit mode

  // ---- Pagination state ----
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const topViewNavData = {
    title: "Vehicle Type",
    backPathRoute: "/dashboard",
  };

  // Open dialog in ADD mode
  const handleRoute = () => {
    setEditId(null);
    setVehicleTypeInput("");
    setVehicleTypeError("");
    setOpenDialog(true);
  };

  // Open dialog in EDIT mode
  const handleEdit = (row) => {
    setEditId(row.id);
    setVehicleTypeInput(row.vehicleType || row.name || "");
    setVehicleTypeError("");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setVehicleTypeInput("");
    setVehicleTypeError("");
    setEditId(null);
  };

  const handleVehicleTypeChange = (e) => {
    setVehicleTypeInput(e.target.value);
    if (e.target.value.trim()) {
      setVehicleTypeError("");
    }
  };

  const handleSaveVehicleType = async () => {
    if (!vehicleTypeInput.trim()) {
      setVehicleTypeError("Vehicle type is required");
      return;
    }

    try {
      setSaving(true);
      let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
      const payload = {
        hrmsUserId: hrmsID && hrmsID,
        userId: JSON.parse(localStorage.getItem("data")).id,
        id: editId,
        name: vehicleTypeInput,
      };

      const res = await VehicleActions.fetchSaveVehicleType(payload);
      console.log(res);
      if (res !== null) {
        handleCloseDialog();
        fetchVehicleTypeList();
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setSaving(false);
    }
  };

  const fetchVehicleTypeList = async () => {
    try {
      let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
      const data = {
        hrmsUserId: hrmsID && hrmsID,
        userId: JSON.parse(localStorage.getItem("data")).id,
        siteId: selectedSite ? selectedSite?.id : null,
      };

      const res = await VehicleActions.fetchVehicleTypeList(data);
      if (res !== null) {
        console.log(res);
        setVehicleTypeList(res?.data);
      } else {
        setVehicleTypeList([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchVehicleTypeList();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <main className="contents__root">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
            }}
          >
            <TopViewNav topViewNavData={topViewNavData} isDetails={true} />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Box>
                <div className="field_box">
                  <div
                    className="field_box_btn1"
                    onClick={handleRoute}
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                    }}
                  >
                    Add Vehicle Type
                  </div>
                </div>
              </Box>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow
                  sx={{
                    ".MuiTableCell-root": {
                      backgroundColor: "rgb(32 80 130)",
                      color: "#fff",
                      div: {
                        width: 170,
                        textAlign: "left",
                      },
                    },
                  }}
                >
                  <TableCell>
                    <strong>S.No</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Vehicle Type</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vehicleTypeList && vehicleTypeList.length > 0 ? (
                  vehicleTypeList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                      <TableRow key={item.id || index}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          {item.vehicleType || item.name || "-"}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="Edit">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(item)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No vehicle types found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {/* <TablePagination
              component="div"
              count={vehicleTypeList ? vehicleTypeList.length : 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            /> */}
          </TableContainer>
        </Grid>
      </Grid>

      {/* ---- Add / Edit Vehicle Type Dialog ---- */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {editId ? "Update Vehicle Type" : "Add Vehicle Type"}
          <IconButton onClick={handleCloseDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            autoFocus
            fullWidth
            label="Vehicle Type"
            placeholder="Enter vehicle type (e.g. Tata Ace)"
            value={vehicleTypeInput}
            onChange={handleVehicleTypeChange}
            error={!!vehicleTypeError}
            helperText={vehicleTypeError}
            sx={{ mt: 1 }}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseDialog} disabled={saving}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveVehicleType}
            disabled={saving}
          >
            {saving ? "Saving..." : editId ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </main>
  );
};

export default VehicleType;

// import {
//   Avatar,
//   Button,
//   Grid,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Tooltip,
//   TablePagination,
// } from "@mui/material";
// import React, { Suspense, lazy } from "react";
// import TopViewNav from "../CommonComponents/TopViewNav";
// import "./Client.css";
// import { useState } from "react";
// import { Box } from "@mui/system";
// import { useNavigate } from "react-router";
// import { useLocalStorage } from "../../Hooks/Index";
// import { VehicleActions } from "../../../actions/VehicleActions";
// import { useEffect } from "react";

// const ImportExcel = lazy(
//   () => import("../CustomeForm/ImportExcel/ImportExcel"),
// );

// const VehicleType = () => {
//   const navigate = useNavigate();

//   const [selectedSite] = useLocalStorage("selectedSite", null);

//   const [vehicleTypeList, setVehicleTypeList] = useState([]);

//   const topViewNavData = {
//     title: "Vehicle Type",
//     backPathRoute: "/dashboard",
//   };

//   const handleRoute = () => {
//     navigate("/vehicle-type/add");
//   };

//   const fetchVehicleTypeList = async () => {
//     try {
//       let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
//       const data = {
//         hrmsUserId: hrmsID && hrmsID,
//         userId: JSON.parse(localStorage.getItem("data")).id,
//         siteId: selectedSite ? selectedSite?.id : null,
//       };

//       const res = await VehicleActions.fetchVehicleTypeList(data);
//       if (res !== null) {
//         console.log(res);
//         setVehicleTypeList(res?.data);
//       } else {
//         setVehicleTypeList([]);
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   useEffect(() => {
//     fetchVehicleTypeList();
//   }, [])

//   return (
//     <main className="contents__root">
//       <Grid container spacing={1}>
//         <Grid item xs={12}>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "end",
//               justifyContent: "space-between",
//             }}
//           >
//             <TopViewNav topViewNavData={topViewNavData} isDetails={true} />
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//               }}
//             >
//               <Box>
//                 <div className="field_box">
//                   <div
//                     className="field_box_btn1"
//                     onClick={handleRoute}
//                     style={{
//                       cursor: "pointer",
//                       padding: "8px",
//                     }}
//                   >
//                     Add Vehicle Type
//                   </div>
//                 </div>
//               </Box>
//             </div>
//           </Box>
//         </Grid>
//         <Grid item xs={12}></Grid>
//       </Grid>
//     </main>
//   );
// };

// export default VehicleType;
